import { Link } from 'react-router-dom';
import { ViewMode } from './list-controls';

/**
 * The "add new" entry point dropped into the same `<ul>` / `.item-grid` container as real
 * `ItemCard`s — mirrors its list/grid duality so it sits naturally alongside them. Supports two
 * mutually-exclusive trigger modes: `to` for plain navigation (the library's "add new" links
 * straight to /upload), or `onClick` for a click-to-reveal trigger (a playlist's "add new" toggles
 * its video picker's visibility rather than navigating anywhere — see design.md Decision 2).
 */
export function AddNewTile({
  viewMode,
  label,
  to,
  onClick,
}: {
  viewMode: ViewMode;
  label: string;
  to?: string;
  onClick?: () => void;
}) {
  const className = `card add-new-tile${viewMode === 'grid' ? ' add-new-tile-grid' : ''}`;
  const content = (
    <>
      <span className="add-new-icon" aria-hidden="true">
        +
      </span>
      <span>{label}</span>
    </>
  );

  const tile = to ? (
    <Link to={to} className={className}>
      {content}
    </Link>
  ) : (
    <button type="button" className={className} onClick={onClick}>
      {content}
    </button>
  );

  if (viewMode === 'grid') return tile;
  return <li style={{ marginBottom: 'var(--space-3)' }}>{tile}</li>;
}
